import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  timeout: 25000,
  withCredentials: true, // send/receive session cookie
});

// Public endpoints
export const searchTickers = (q, options = {}) =>
  http.get(`/search`, { params: { q }, signal: options.signal }).then((r) => r.data);
export const getQuote = (symbol) => http.get(`/quote/${encodeURIComponent(symbol)}`).then((r) => r.data);
export const getEtfInfo = (symbol) =>
  http.get(`/etf-info/${encodeURIComponent(symbol)}`).then((r) => r.data);
export const getEtfsHoldingStock = (symbol) =>
  http.get(`/etfs-holding/${encodeURIComponent(symbol)}`).then((r) => r.data);
export const getPeerEtfs = (symbol) =>
  http.get(`/peer-etfs/${encodeURIComponent(symbol)}`).then((r) => r.data);
export const getEtfsByType = (typeId) =>
  http.get(`/etfs-by-type/${encodeURIComponent(typeId)}`).then((r) => r.data);
export const computeTotalReturn = (symbol, intervals) =>
  http.post(`/total-return`, { symbol, intervals }).then((r) => r.data);

// Auth
export const exchangeSession = (sessionId) =>
  http.post(`/auth/google/session`, null, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);
export const fetchMe = () => http.get(`/auth/me`).then((r) => r.data);
export const updateMe = (patch) => http.patch(`/auth/me`, patch).then((r) => r.data);
export const logout = () => http.post(`/auth/logout`).then((r) => r.data);

// Watchlists
export const listWatchlists = () => http.get(`/watchlists`).then((r) => r.data);
export const createWatchlist = (name, tickers = []) =>
  http.post(`/watchlists`, { name, tickers }).then((r) => r.data);
export const updateWatchlist = (id, patch) => http.patch(`/watchlists/${id}`, patch).then((r) => r.data);
export const deleteWatchlist = (id) => http.delete(`/watchlists/${id}`).then((r) => r.data);
export const addTickerToWatchlist = (id, symbol) =>
  http.post(`/watchlists/${id}/tickers`, { symbol }).then((r) => r.data);
export const removeTickerFromWatchlist = (id, symbol) =>
  http.delete(`/watchlists/${id}/tickers/${encodeURIComponent(symbol)}`).then((r) => r.data);

// Public watchlist (no auth)
export const fetchPublicWatchlist = (id) =>
  http.get(`/public/watchlists/${id}`).then((r) => r.data);

// Digest
export const digestPreview = (watchlistId) =>
  http.post(`/digest/preview`, { watchlist_id: watchlistId }).then((r) => r.data);
export const sendDigestEmail = (watchlistId) =>
  http.post(`/digest/send`, { watchlist_id: watchlistId }).then((r) => r.data);
